module.exports = __webpack_public_path__ + "img/BT_greeting_NO.b873c656.svg";